import React from 'react'
import {
  Grid,  Typography, Box } from '@mui/material'
import {
  PublicPageLayout,
  getNextLevelLogoProps,
} from '@/housefolios-components/PublicPages/shared'

function PublicTurnkeyPage(props) {
  const { logoSrc, logoAlt } = getNextLevelLogoProps(props.marketplace)

  return (
    <PublicPageLayout
      title={
        props.marketplace
          ? `${props.marketplace.name} Turnkey Process`
          : 'Turnkey Process'
      }
      description="Learn about our turnkey investment process"
      icon={logoSrc ? undefined : null}
      logoSrc={logoSrc}
      logoAlt={logoAlt}
      containerProps={{
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 5}}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1200,
          marginTop: 4}}
      >
        <Grid container spacing={4}>
          {/* Placeholder Content */}
          <Grid size={12}>
            <Typography variant="h4" component="h2" gutterBottom>
              Our Turnkey Investment Process
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Content coming soon - This page will explain our turnkey investment
              process, including how we identify properties, handle renovations,
              manage properties, and provide returns to investors.]
            </Typography>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Typography variant="h5" component="h3" gutterBottom>
              Step 1: Property Acquisition
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Placeholder: Description of how we identify and acquire investment
              properties.]
            </Typography>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Typography variant="h5" component="h3" gutterBottom>
              Step 2: Renovation & Improvement
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Placeholder: Description of our renovation process and quality
              standards.]
            </Typography>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Typography variant="h5" component="h3" gutterBottom>
              Step 3: Property Management
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Placeholder: Description of our property management services and
              tenant relations.]
            </Typography>
          </Grid>

          <Grid size={{xs: 12, md: 6}}>
            <Typography variant="h5" component="h3" gutterBottom>
              Step 4: Investor Returns
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Placeholder: Description of how investors receive returns and the
              benefits of our turnkey process.]
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </PublicPageLayout>
  );
}

export default PublicTurnkeyPage
